import { compose } from 'react-recompose';
import _ from 'lodash';

const getData = response => response.data;
const extract = response => response.data.content;
const extract1 = response => response.data.content[0];

const validateStatus = response => {
  // Check for a server error
  if (_.includes([503, 504], response.status)) {
    throw new ApiError(
      response.status,
      'The platform is experiencing an issue at this time and cannot perform the operation. Please try again later.',
      []
    );
  }

  return response;
};

/**
 * Validate response; invalid API responses return successfully and contain error details within
 * @param {object} response  API reponse object
 * @return {object} the response to be handled downstream by the promise
 */
const validateData = response => {
  if (response.data.status !== 'ok') {
    const { status, statusmsg /*statuscode */ } = response.data;
    if (status === 'warning') {
      displayMessage({ status, message: statusmsg });
    } else {
      throw new ApiError(status, statusmsg);
    }
  }
  return response;
};

/**
 * Validate response from a bulk request (i.e. updating a list of objects)
 * @param {object} response  API reponse object
 * @return {object} the response to be handled downstream by the promise
 */
const validateDataList = response => {
  if (response.data.status !== 'ok') {
    const { status, statusmsg /*statuscode */ } = response.data;
    const successes = _.get(response.data, 'content', []);
    const failures = _.get(response.data, 'failed', []);
    const failureIds = _.map(failures, 'id');

    let message = '';
    if (successes.length > 0 && failures.length > 0) {
      message = `${statusmsg} failed for ${failures.length}/${successes.length +
        failures.length} items.\nIDs: ${failureIds.join(', ')}`;
    } else {
      message = `${statusmsg} failed for ${
        failures.length > 1 ? `all ${failures.length} items.` : '1 item.'
      }\nIDs: ${failureIds.join(', ')}`;
    }

    if (successes.length > 0) {
      displayMessage({ status, message });
    } else {
      throw new ApiError(status, message);
    }
  }
  return response;
};

const validate = compose(validateData, validateStatus);
const validateAll = compose(validateDataList, validateStatus);

/**
 * Print out a message of type `status`
 * @param {object}  message data object with shape:
 *   status: {['error', 'warning', 'success']}
 *   message: {string}
 */
const displayMessage = ({ status, message = '' }) => {
  App.drawMessage({
    status: status === null || status === undefined || status === '' ? 'warning' : status,
    message,
  });
};

/**
 * ApiError definition
 * @param {number} code  status code
 * @param {string} message  status message
 */
function ApiError(code, message) {
  this.code = code;
  this.status = 'error';
  this.message = message;
  this.stack = new Error().stack;
  this.name = 'ApiError';
}
ApiError.prototype = Object.create(Error.prototype);
ApiError.prototype.constructor = ApiError;

export { getData, extract, extract1, validate, validateAll, validateStatus, displayMessage, ApiError };
